import { render, staticRenderFns } from "./MigrateAccount.vue?vue&type=template&id=efaecbc0"
import script from "./MigrateAccount.vue?vue&type=script&lang=ts"
export * from "./MigrateAccount.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports